import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import { media, styled } from "./mediaCSS"

import {
  FaHome,
  FaUtensils,
  FaCommentDollar,
  FaInfoCircle,
  FaCalendarAlt,
} from "react-icons/fa"

const MobilePWAFooterSC = styled.footer`
background: darkblue;
height: 80px;
width: 100%;
position: fixed;
bottom: 0;
display: none;
justify-content: space-between;


align-items: center;
font-size: 10px;
color: white;




${media.tablet_desktop`
  display: none;
`}

${media.mobile`
 display: none;
`}


${media.mobilePWA`
  display: flex;
`}
`

const StyledLink = styled(props => <Link {...props} />)`
  color: white;
  text-align: center;
  flex: 1;
`

const MobilePWAFooter = ({ siteTitle }) => (
  <MobilePWAFooterSC>
    <StyledLink to="/" activeClassName="active">
      <FaHome size={24} />
      <h2>Home</h2>
    </StyledLink>
    <StyledLink to="/menu/" activeClassName="active">
      <FaUtensils size={24} />
      <h2>Menu</h2>
    </StyledLink>
    <StyledLink to="/specials/" activeClassName="active">
      <FaCommentDollar size={24} />
      <h2>Specials</h2>
    </StyledLink>
    <StyledLink to="/staff/" activeClassName="active">
      <FaInfoCircle size={24} />
      <h2>About Us</h2>
    </StyledLink>
    <StyledLink to="/events/" activeClassName="active">
      <FaCalendarAlt size={24} />
      <h2>Events</h2>
    </StyledLink>
  </MobilePWAFooterSC>
)
export default MobilePWAFooter
